export default "__VITE_ASSET__5b3e27c3__"